





















import { Component, Prop, Emit, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { ModalCodeAddress } from '@/components/modals/ModalCodeAddress'
import {
  AlertMessage,
  ErrorMessage,
  SystemCodeAddress,
  systemCodeAddressApi
} from '@/api'
import { alertStore, modalErrorStore } from '@/utils/store-accessor'
import { AtomTextField } from '@/components/atoms'
import { merge } from 'lodash'

const CODE_MAX_LENGTH = 6

@Component({
  components: {
    ModalCodeAddress
  }
})
export default class InputCodeAddress extends ComponentVue {
  @Ref()
  textField!: AtomTextField

  @Ref()
  modalCodeAddress!: ModalCodeAddress

  @Prop({ type: String })
  label!: string

  @Prop({ type: String })
  placeholder!: string

  @Prop({ type: Object })
  value!: SystemCodeAddress

  @Prop({
    type: Boolean,
    default: false
  })
  hideName!: boolean

  @Prop({
    type: Boolean,
    default: true
  })
  hideDetails!: boolean

  @Prop({ type: Boolean, default: false })
  error!: boolean

  @Prop({ type: String, default: '' })
  errorMessage!: string

  @Prop({
    type: Boolean,
    default: false
  })
  flat!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  outlined!: boolean

  // SystemCodeAddressのどの値を使用するか判定を取るprops
  @Prop({
    type: String,
    default: 'code'
  })
  valueProperty!: string

  systemCodes: SystemCodeAddress[] = []

  get mask(): string {
    if (this.valueProperty === 'code') {
      return 'X'.repeat(CODE_MAX_LENGTH)
    } else if (this.valueProperty === 'zipCode') {
      return '###-####'
    }

    return ''
  }

  get suffix(): string {
    if (this.hideName) {
      return ''
    }

    return (
      this.systemCodes.find(
        systemCode =>
          (systemCode as any)[this.valueProperty] ===
          (this.value as any)[this.valueProperty]
      )?.name ?? ''
    )
  }

  created() {
    this.fetchAddressCode()
  }

  activated() {
    this.fetchAddressCode()
  }

  onInput(value: string) {
    if (
      (this.valueProperty === 'code' && value.length === CODE_MAX_LENGTH) ||
      (this.valueProperty === 'zipCode' && value.length === 8)
    ) {
      const systemCodeAddress:
        | SystemCodeAddress
        | undefined = this.systemCodes.find(
        (systemCode: any) => systemCode[this.valueProperty] === value
      )

      if (systemCodeAddress !== undefined) {
        this.$emit('input', systemCodeAddress)
        return
      }
    }

    this.$emit(
      'input',
      merge({ ...this.value }, { [this.valueProperty]: value })
    )
  }

  onModalCodeAddressInput(item: SystemCodeAddress): void {
    this.$emit('input', item)
    this.$emit('input:modal', item)
  }

  async fetchAddressCode() {
    try {
      this.systemCodes = await systemCodeAddressApi.getAllSystemCodeAddress()
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    }
  }

  @Emit('click:list')
  onListClick(): void {
    this.modalCodeAddress.open()
  }

  @Emit('keydown:enter')
  onKeydownEnter() {}
}
